const MICRO_SERVICE_URL_IMPORT = "inter-importacao";
import api from './api';

class ImportHistory {
    async getAll(resourceName, params) {
        const user = JSON.parse(localStorage.getItem('user'));

        if (user && user.email) params.importerEmail = user.email;

        const response = await api.get(`${MICRO_SERVICE_URL_IMPORT}/api/file/${resourceName}`, { params: params });
        return response.data;
    }
    async hasImportHistory(resourceName) {
        const response = await api.get(`${MICRO_SERVICE_URL_IMPORT}/api/file/${resourceName}?limit=1&page=1`);
        return response.data;
    }
    async downloadCsvImport(resourceName, fileName, id) {
        const response = await api.get(`${MICRO_SERVICE_URL_IMPORT}/api/file/download/${resourceName}/${id}`, { responseType: 'blob' })
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${fileName}.csv`);
        document.body.appendChild(fileLink);
        fileLink.click();
    }
    async downloadCsvResult(resourceName, fileName, id) {
        const response = await api.get(`${MICRO_SERVICE_URL_IMPORT}/api/file/download/${resourceName}/result/${id}`, { responseType: 'blob' })
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${fileName}.csv`);
        document.body.appendChild(fileLink);
        fileLink.click();
    }
}

export default new ImportHistory();